import React, { useEffect, useState } from 'react'
import { BtInput } from '@linqpal/components/src/ui'
import { observer } from 'mobx-react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { Spacer } from '../../../../../ui/atoms'
import { Instance, types } from 'mobx-state-tree'
import { CompProps } from '../../Editor'
import { editableModel } from '@linqpal/models'
import { toJS } from 'mobx'
import { Description } from '../../components'

const BusinessNameModel = types.model('BusinessName', {
  legalName: '',
  dba: '',
})

type BusinessNameModelType = Instance<typeof BusinessNameModel>

const BusinessNameStore = types
  .compose(BusinessNameModel, editableModel())
  .named('BusinessNameStore')

const BusinessNameStep: React.FC<CompProps> = ({
  doc,
  group,
  item,
  review,
  sm,
  onValueUpdate,
}) => {
  const { t } = useTranslation('application')
  const [store, setStore] = useState(
    BusinessNameStore.create({ legalName: '', dba: '' }),
  )

  const validate = (model: BusinessNameModelType | null) => !!model?.legalName

  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    null,
    validate,
    BusinessNameModel,
  )

  useEffect(() => {
    if (
      model.value &&
      (model.value?.legalName !== store.legalName ||
        model.value?.dba !== store.dba)
    ) {
      setStore(BusinessNameStore.create(toJS(model.value)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUpdate =
    (key: keyof BusinessNameModelType) => (value: string) => {
      store.setValue(key as string, value)
      model.setValue(item, store)
    }

  return (
    <>
      <Spacer height={review ? 24 : 4} />
      <BtInput
        size="large"
        testID="BusinessNameInput"
        value={model.value?.legalName || ''}
        label={t('Business.NameLabel')}
        onChangeText={handleUpdate('legalName')}
      />

      <Spacer height={review ? 24 : 4} />

      {!review && (
        <Description
          description={'Business.DbaTitle' as string}
          style={{ marginTop: 24 } as any}
          sm={sm}
          t={t}
        />
      )}

      <BtInput
        size="large"
        testID="DbaInput"
        value={model.value?.dba || ''}
        label={t('Business.DbaLabel')}
        onChangeText={handleUpdate('dba')}
      />
    </>
  )
}

export default {
  title: 'Business.Name',
  description: 'Business.NameDescription',
  component: observer(BusinessNameStep),
}
